import { useSearchParams } from "react-router-dom"
import { DatePicker } from "@mui/x-date-pickers"
import { makeStyles } from "tss-react/mui"
import { DateTime } from "luxon"
import { DateFilterParams } from "./useInitialDateFilters"

const useStyles = makeStyles()(() => ({
    dateFilter: {
        maxWidth: "11rem",
    },
}))

type DateFilterProps = {
    value: DateTime | null
    onChange: (newValue: DateTime) => void
    label: string
    paramName: DateFilterParams
    minDate?: DateTime | undefined
    maxDate?: DateTime | undefined
    classNameUpdate?: string
}

export const StandardDateFilter = ({
    value,
    onChange,
    label,
    paramName,
    minDate,
    maxDate,
    classNameUpdate,
}: DateFilterProps) => {
    const { classes, cx } = useStyles()
    const [searchParams, setSearchParams] = useSearchParams()

    const handleDateChange = (newValue: DateTime | null) => {
        if (newValue && (!value || !newValue.equals(value))) {
            onChange(newValue)
            searchParams.set(paramName, newValue.toISODate() || "")
            setSearchParams(searchParams)
        }
    }

    return (
        <DatePicker
            className={cx(classes.dateFilter, classNameUpdate)}
            value={value}
            onChange={handleDateChange}
            label={label}
            minDate={minDate}
            maxDate={maxDate}
        />
    )
}
